/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { RealtimeEventsControllerGetRealtimeAuthTokenQueryResponse } from "../../models/realtimeEventsController/RealtimeEventsControllerGetRealtimeAuthToken";

function getRealtimeEventsControllerGetRealtimeAuthTokenUrl() {
  const res = { method: 'GET', url: `/api/v1/realtime/auth` as const }  
  return res
}

/**
 * @summary Get realtime authentication token
 * {@link /api/v1/realtime/auth}
 */
export async function realtimeEventsControllerGetRealtimeAuthToken(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<RealtimeEventsControllerGetRealtimeAuthTokenQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getRealtimeEventsControllerGetRealtimeAuthTokenUrl().url.toString(), ... requestConfig })  
  return res.data
}